// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metrics-page {
  padding: 1rem;
}
.metrics-page h3 {
  margin-bottom: 1rem;
}
.metrics-page .two-panel-layout {
  align-items: start;
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(280px, 360px) 1fr;
}
.metrics-page .left-panel,
.metrics-page .right-panel {
  min-width: 0;
}
.metrics-page .left-panel {
  border-right: 1px solid #dee2e6;
  padding-right: 1rem;
}
.metrics-page .panel-toolbar {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.metrics-page .panel-toolbar h4 {
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}
.metrics-page .results-toolbar {
  gap: 0.75rem;
}
.metrics-page .total-count {
  color: #6c757d;
  font-size: 0.9rem;
}
.metrics-page .metrics-form {
  display: flex;
  flex-direction: column;
}
.metrics-page .field-row {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}
.metrics-page .field-label {
  flex: 0 0 110px;
  margin: 0;
}
.metrics-page .field-value {
  flex: 1 1 auto;
  min-width: 0;
}
.metrics-page .field-value .form-control {
  width: 100%;
}
.metrics-page .general-error {
  color: #dc3545;
  font-size: 0.85em;
  margin: -0.25rem 0 0.75rem;
}
.metrics-page .form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.25rem;
}
.metrics-page .form-actions .btn-spinner {
  display: inline-block;
  margin-right: 6px;
  vertical-align: middle;
}
.metrics-page .responsive-table {
  max-height: 68vh;
  min-height: 190px;
  overflow: auto;
  border-radius: 4px;
}
.metrics-page .charts-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 1rem;
}
.metrics-page .chart-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.75rem;
}
.metrics-page .chart-card h5 {
  color: #0b2d71;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0 0 0.5rem;
}
.metrics-page .chart-container {
  min-height: 360px;
  position: relative;
}
.metrics-page .chart-container canvas {
  height: 360px !important;
  width: 100% !important;
}
.metrics-page .chart-empty {
  align-items: center;
  color: #6c757d;
  display: flex;
  inset: 0;
  justify-content: center;
  position: absolute;
}
.metrics-page table {
  background-color: #f7f7f7;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}
.metrics-page th,
.metrics-page td {
  padding: 0 12px;
}
.metrics-page th {
  background-color: #E4ECF2;
  color: #0b2d71;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 2;
}
.metrics-page tbody tr:hover {
  background-color: #f5f5f5;
}
.metrics-page .count-column {
  text-align: right;
  width: 110px;
}
.metrics-page .loading-state,
.metrics-page .empty-state {
  align-items: center;
  color: #6c757d;
  display: flex;
  justify-content: center;
  min-height: 190px;
}
.metrics-page .loading-state {
  flex-direction: column;
  gap: 12px;
}
@media (max-width: 720px) {
  .metrics-page .two-panel-layout {
    grid-template-columns: 1fr;
  }
  .metrics-page .left-panel {
    border-bottom: 1px solid #dee2e6;
    border-right: 0;
    padding: 0 0 1rem;
  }
  .metrics-page .field-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.25rem;
  }
  .metrics-page .field-label {
    flex-basis: auto;
  }
  .metrics-page .charts-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/metrics-page/metrics-page.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,+CAAA;AAFJ;AAKE;;EAEE,YAAA;AAHJ;AAME;EACE,+BAAA;EACA,mBAAA;AAJJ;AAOE;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AALJ;AAOI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AALN;AASE;EACE,YAAA;AAPJ;AAUE;EACE,cAAA;EACA,iBAAA;AARJ;AAWE;EACE,aAAA;EACA,sBAAA;AATJ;AAYE;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;AAVJ;AAaE;EACE,eAAA;EACA,SAAA;AAXJ;AAcE;EACE,cAAA;EACA,YAAA;AAZJ;AAeE;EACE,WAAA;AAbJ;AAgBE;EACE,cAAA;EACA,iBAAA;EACA,0BAAA;AAdJ;AAiBE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;AAfN;AAmBE;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,SAAA;EACA,gDAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AAnBJ;AAqBI;EACE,cChHM;EDiHN,kBAAA;EACA,gBAAA;EACA,kBAAA;AAnBN;AAuBE;EACE,iBAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,wBAAA;EACA,sBAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;AAvBJ;AA0BE;EACE,yBCnHY;EDoHZ,yBAAA;EACA,iBAAA;EACA,WAAA;AAxBJ;AA2BE;;EAEE,eAAA;AAzBJ;AA4BE;EACE,yBCvHW;EDwHX,cCxJQ;EDyJR,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AA1BJ;AA6BE;EACE,yBAAA;AA3BJ;AA8BE;EACE,iBAAA;EACA,YAAA;AA5BJ;AA+BE;;EAEE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;AA7BJ;AAgCE;EACE,sBAAA;EACA,SAAA;AA9BJ;AAiCE;EACE;IACE,0BAAA;EA/BJ;EAkCE;IACE,gCAAA;IACA,eAAA;IACA,iBAAA;EAhCJ;EAmCE;IACE,uBAAA;IACA,sBAAA;IACA,YAAA;EAjCJ;EAoCE;IACE,gBAAA;EAlCJ;EAqCE;IACE,0BAAA;EAnCJ;AACF","sourcesContent":["@use '../../../../styles/colors' as colors;\n\n.metrics-page {\n  padding: 1rem;\n\n  h3 {\n    margin-bottom: 1rem;\n  }\n\n  .two-panel-layout {\n    align-items: start;\n    display: grid;\n    gap: 1rem;\n    grid-template-columns: minmax(280px, 360px) 1fr;\n  }\n\n  .left-panel,\n  .right-panel {\n    min-width: 0;\n  }\n\n  .left-panel {\n    border-right: 1px solid #dee2e6;\n    padding-right: 1rem;\n  }\n\n  .panel-toolbar {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n\n    h4 {\n      font-size: 1rem;\n      font-weight: 500;\n      margin: 0;\n    }\n  }\n\n  .results-toolbar {\n    gap: 0.75rem;\n  }\n\n  .total-count {\n    color: #6c757d;\n    font-size: 0.9rem;\n  }\n\n  .metrics-form {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .field-row {\n    align-items: center;\n    display: flex;\n    gap: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .field-label {\n    flex: 0 0 110px;\n    margin: 0;\n  }\n\n  .field-value {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .field-value .form-control {\n    width: 100%;\n  }\n\n  .general-error {\n    color: #dc3545;\n    font-size: 0.85em;\n    margin: -0.25rem 0 0.75rem;\n  }\n\n  .form-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 0.25rem;\n\n    .btn-spinner {\n      display: inline-block;\n      margin-right: 6px;\n      vertical-align: middle;\n    }\n  }\n\n  .responsive-table {\n    max-height: 68vh;\n    min-height: 190px;\n    overflow: auto;\n    border-radius: 4px;\n  }\n\n  .charts-grid {\n    display: grid;\n    gap: 1rem;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    margin-top: 1rem;\n  }\n\n  .chart-card {\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n    padding: 0.75rem;\n\n    h5 {\n      color: colors.$dark-blue;\n      font-size: 0.95rem;\n      font-weight: 600;\n      margin: 0 0 0.5rem;\n    }\n  }\n\n  .chart-container {\n    min-height: 360px;\n    position: relative;\n  }\n\n  .chart-container canvas {\n    height: 360px !important;\n    width: 100% !important;\n  }\n\n  .chart-empty {\n    align-items: center;\n    color: #6c757d;\n    display: flex;\n    inset: 0;\n    justify-content: center;\n    position: absolute;\n  }\n\n  table {\n    background-color: colors.$lightest-gray;\n    border-collapse: separate;\n    border-spacing: 0;\n    width: 100%;\n  }\n\n  th,\n  td {\n    padding: 0 12px;\n  }\n\n  th {\n    background-color: colors.$lighter-blue;\n    color: colors.$dark-blue;\n    font-weight: 600;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n  }\n\n  tbody tr:hover {\n    background-color: #f5f5f5;\n  }\n\n  .count-column {\n    text-align: right;\n    width: 110px;\n  }\n\n  .loading-state,\n  .empty-state {\n    align-items: center;\n    color: #6c757d;\n    display: flex;\n    justify-content: center;\n    min-height: 190px;\n  }\n\n  .loading-state {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  @media (max-width: 720px) {\n    .two-panel-layout {\n      grid-template-columns: 1fr;\n    }\n\n    .left-panel {\n      border-bottom: 1px solid #dee2e6;\n      border-right: 0;\n      padding: 0 0 1rem;\n    }\n\n    .field-row {\n      align-items: flex-start;\n      flex-direction: column;\n      gap: 0.25rem;\n    }\n\n    .field-label {\n      flex-basis: auto;\n    }\n\n    .charts-grid {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
